<template>
  <div>
    <div class="profile-scroing">
      <div class="row">
        <div
          class="col-md-3"
          v-if="can([Permissions.backend.profileScoring.list])"
        >
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">
                {{ $t('list.criteria') }}
              </h3>
              <div class="box-tools">
                <template v-if="can([Permissions.backend.profileScoring.edit])">
                  <button
                    class="btn btn-primary btn-xs margin-right-5"
                    data-toggle="modal"
                    data-target="#criteriaModal"
                  >
                    <i class="fa fa-edit" />
                  </button>
                </template>
                <template v-if="can([Permissions.backend.profileScoring.calculate])">
                  <button
                    class="btn btn-success btn-xs"
                    @click="calculateScore"
                  >
                    <i class="fa fa-refresh" /> {{ $t('button.calculateScore') }}
                  </button>
                </template>
              </div>
            </div>
            <div class="box-body">
              <div class="list-group">
                <a
                  href="#"
                  @click="changeActiveItem(item)"
                  :key="key"
                  :class="`list-group-item ${item.selected ? 'active' : null}`"
                  v-for="(item, key) in criteria"
                >
                  {{ item.name }}
                  <div class="pull-right">
                    <i
                      class="fa fa-circle"
                      :style="`color:${item.active ? 'green': 'red'}`"
                    />
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-9">
          <div class="row">
            <div
              class="col-md-12"
              v-if="can([Permissions.backend.profileScoring.viewStatisticProfileScoring])"
            >
              <cash-hero-statistic />
            </div>
            <div
              class="col-md-12"
              v-if="can([Permissions.backend.criteriaScore.list])"
            >
              <div class="box box-primary">
                <div class="box-header with-border">
                  <h3 class="box-title">
                    {{ $t('list.score') }}
                  </h3>
                  <div class="box-tools">
                    <template v-if="can([Permissions.backend.criteriaScore.store])">
                      <button
                        class="btn btn-primary btn-sm"
                        data-toggle="modal"
                        @click="resetStateScoreModal"
                        data-target="#newScoreModal"
                      >
                        {{ $t('button.newScore') }}
                      </button>
                    </template>
                  </div>
                </div>
                <div class="box-body">
                  <div>
                    <table
                      id="criteria-table"
                      class="table table-hover table-striped table-bordered"
                    >
                      <thead>
                        <tr>
                          <th>{{ $t('table.action') }}</th>
                          <th>{{ $t('table.createdAt') }}</th>
                          <th>{{ $t('table.value') }}</th>
                          <th>{{ $t('table.score') }}</th>
                        </tr>
                      </thead>
                      <tbody />
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <score-modal
      @refreshTable="refreshDataTable"
      ref="scoreModal"
    />
    <criteria-modal
      @refreshTable="getCriteria"
      ref="criteriaModal"
    />
  </div>
</template>

<script>
import ScoreModal from './ScoreModal'
import CriteriaModal from './CriteriaModal'
import CashHeroStatistic from '@/components/CashHeroStatistic'
import Permissions from '@/permissions'
import { mapFields } from 'vuex-map-fields'

export default {
  name: 'List',
  components: {
    CashHeroStatistic,
    CriteriaModal,
    ScoreModal
  },
  metaInfo () {
    return {
      title: this.$t('string.listCriteria'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  },
  data () {
    return {
      oTable: null,
      scores: [],
      Permissions
    }
  },
  computed: {
    ...mapFields('profileScoring', {
      criteria: 'criteria',
      selectedCriteria: 'selectedCriteria'
    })
  },
  watch: {
    '$i18n.locale': function () {
      if (this.oTable !== null) {
        this.oTable.destroy()
        this.oTable = this.refreshTable()
        this.oTable.draw(true)
        this.loadAction()
        this.$store.dispatch('profileScoring/changeCriteriaLabel', this.$i18n.locale)
      }
    },
    'selectedCriteria' () {
      if (this.can([this.$Permissions.backend.criteriaScore.list])) {
        this.oTable.draw(true)
      }
    }
  },
  methods: {
    resetStateScoreModal () {
      this.$refs.scoreModal.resetState()
      this.$refs.criteriaModal.resetState()
    },
    calculateScore () {
      this.$isLoading(true)
      this.$axios.post(process.env.VUE_APP_API + '/api/v1/borrows/calculate-borrower-score', {
        status: ['Pending', 'Approved']
      }).then(() => {
        this.oTable.draw(true)
        this.$toastr(
          'success',
          this.$t('string.theRequestHaveBeenProceeded'),
          this.$t('string.calculated')
        )
      }).finally(() => {
        this.$isLoading(false)
      })
    },
    getCriteria () {
      this.$axios.post(process.env.VUE_APP_API + '/api/v1/profile-scoring/get-criterias')
        .then((response) => {
          if (response.data.code === 1) {
            const result = response.data.data
            const lang = this.$i18n.locale
            result.map((item, key) => {
              if (lang === 'en') {
                this.$set(item, 'name', item.name_en)
              } else {
                this.$set(item, 'name', item.name_km)
              }
              if (key === 0) {
                this.$set(item, 'selected', true)
                this.$set(item, 'selected', true)
              } else {
                this.$set(item, 'selected', false)
                this.$set(item, 'selected', false)
              }
              return item
            })
            this.$store.dispatch('profileScoring/setCriteria', result)
            this.$store.dispatch('profileScoring/setSelectedCriteria', result[0])
          }
        })
    },
    changeActiveItem (item) {
      this.$store.dispatch('profileScoring/changeCriteriaSelected', item)
    },
    refreshDataTable () {
      this.oTable.draw(true)
    },
    deleteScore (id) {
      const self = this
      this.$swal({
        title: this.$t('string.areYouSure?'),
        text: this.$t('string.youWillNotBeRevert'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('string.yesIDeleteIt!'),
        cancelButtonText: this.$t('string.cancel')
      }).then((result) => {
        if (result.value) {
          this.$axios.post(process.env.VUE_APP_API + '/api/v1/profile-scoring/delete-criteria-scores', {
            criteria_score_id: id
          }).then((response) => {
            if (response.data.code === 1) {
              this.refreshDataTable()
            }
            self.$swal(
              this.$t('string.deleted'),
              this.$t('string.theRequestHaveBeenProceeded'),
              'success'
            )
          })
        }
      })
    },
    refreshTable () {
      const self = this
      return $('#criteria-table').DataTable({
        stateSave: true,
        processing: true,
        serverSide: true,
        scrollX: true,
        scrollCollapse: true,
        pageLength: process.env.VUE_APP_PAGE_LENGTH,
        lengthMenu: this.$lengthMenu,
        ajax: {
          method: 'POST',
          url: process.env.VUE_APP_API + '/api/v1/profile-scoring/datatable',
          data: (d) => {
            d.labelEdit = self.$t('label.edit')
            d.labelDelete = self.$t('label.delete')
            d.criteria_id = self.selectedCriteria !== null ? self.selectedCriteria.id : -1
            d.noPermission = self.$t('string.noPermission')
          }
        },
        columns: [
          {
            data: 'action',
            name: 'action',
            searchable: false,
            orderable: false,
            width: '8%',
            title: this.$t('table.action')
          },
          {
            data: 'created_at',
            name: 'created_at',
            searchable: false,
            width: '8%',
            title: this.$t('table.createdAt')
          },
          {
            data: 'value',
            name: 'value',
            searchable: false,
            orderable: false,
            width: '8%',
            title: this.$t('table.value')
          },
          {
            data: 'score',
            name: 'score',
            width: '8%',
            title: this.$t('table.score'),
            searchable: false,
            orderable: false
          }
        ],
        language: {
          url: `/locale/${this.$i18n.locale}.json`
        },
        fixedColumns: true
      })
    },
    loadAction () {
      this.clearEventHandlers([
        '.btn-edit',
        '.btn-delete'
      ])
      const self = this
      $(document).on('click', '.btn-delete', function () {
        self.deleteScore($(this).attr('data-id'))
      })
      $(document).on('click', '.btn-edit', function () {
        self.getCriteriaScore($(this).attr('data-id'))
      })
    },
    getCriteriaScore (criteria_score_id) {
      this.$axios.post(process.env.VUE_APP_API + '/api/v1/profile-scoring/show-criteria-score', {
        criteria_score_id: criteria_score_id
      }).then((response) => {
        if (response.data.code === 1) {
          this.$store.commit('profileScoring/setFormDataScore', response.data.data)
        }
      })
    }
  },
  mounted () {
    this.oTable = this.refreshTable()
    this.loadAction()
    this.getCriteria()
  }
}
</script>

<style scoped>

</style>
